<template>
  <v-row class="py-1 px-5 grey lighten-4 fill-height">
    <v-col cols="12">
      <v-row>
        <v-col cols="12" PagingC>
          <Paging :resourceSettings="resourceSettings" :resource="resource" @loadResource="loadResource"
            @pageByNumber="pageByNumber" />
        </v-col>
        <v-col class="mx-auto" cols="2" style="max-width: fit-content;">
          <v-btn @click.prevent="() => (dialog = true)" color="primary">
            <v-icon>add</v-icon>
            <span>New</span>
          </v-btn>
        </v-col>
        <v-col cols="12" updates>
          <v-card class="px-3" :loading="loading">
            <v-card-text>

              <v-row>
                <v-col cols="12" :class="`${arabic ? 'arFont' : 'enFont'}`">

                  <v-expansion-panels>
                    <v-expansion-panel v-for="(contract, key) in resource.data" :key="`contract-${key}`">
                      <v-expansion-panel-header>
                        <v-row justify="center">
                          <v-col md="3" cols="6" class="pa-md-0 px-0">
                            <div style="font-size:11px;font-weight:700;">{{ i18n.country }}</div>
                            <div class="mt-1">
                              <v-chip label color="blue darken-1" dark small>
                                {{ contract.country_name.slug }}
                              </v-chip>
                            </div>
                          </v-col>
                          <v-col md="3" cols="6" class="pa-md-0 px-0">
                            <div style="font-size:11px;font-weight:700;">{{ i18n.program }}</div>
                            <div class="mt-1">
                              <v-chip label color="brown darken-1" dark small>
                                {{ contract.program_name.slug }}
                              </v-chip>
                            </div>
                          </v-col>
                          <v-col md="2" cols="6" class="pa-md-0 px-0">
                            <div style="font-size:11px;font-weight:700;">{{ i18n.valid_start }}</div>
                            <div class="mt-1">
                              <div color="green darken-1" dark small>
                                {{ formatDateToCurrentLocale(contract.valid_start)[0] }}
                              </div>
                            </div>
                          </v-col>
                          <v-col md="2" cols="6" class="pa-md-0 px-0">
                            <div style="font-size:11px;font-weight:700;">{{ i18n.valid_end }}</div>
                            <div class="mt-1">
                              <div color="orange darken-1" dark small>
                                {{ formatDateToCurrentLocale(contract.valid_end)[0] }}
                              </div>
                            </div>
                          </v-col>
                          <v-col md="2" cols="6" class="d-flex pa-md-0 px-0">
                            <div class="my-auto">
                              <v-btn @click.stop="editResource(contract)" x-small color="primary">
                                <v-icon small>create</v-icon>
                                <span>Edit</span>
                              </v-btn>
                              <v-btn @click.stop="triggerDelete(contract)" x-small color="error" class="ml-2">
                                <v-icon small>delete</v-icon>
                                <span>Delete</span>
                              </v-btn>
                            </div>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-header>
                      <v-divider></v-divider>
                      <v-expansion-panel-content>
                        <v-row>
                          <v-col md="3" cols="6" class="px-0">
                            <div style="font-size:11px;font-weight:700;">{{ i18n.first_fees }}</div>
                            <div class="mt-1">
                              {{ contract.first_fees }}
                            </div>
                          </v-col>
                          <v-col md="3" cols="6" class="px-0">
                            <div style="font-size:11px;font-weight:700;">{{ i18n.first_fees_currency }}</div>
                            <div class="mt-1">
                              {{ contract.first_fees_currency }}
                            </div>
                          </v-col>
                          <v-col md="3" cols="6" class="px-0">
                            <div style="font-size:11px;font-weight:700;">{{ i18n.second_fees }}</div>
                            <div class="mt-1">
                              {{ contract.second_fees }}
                            </div>
                          </v-col>
                          <v-col md="3" cols="6" class="px-0">
                            <div style="font-size:11px;font-weight:700;">{{ i18n.second_fees_currency }}</div>
                            <div class="mt-1">
                              {{ contract.second_fees_currency }}
                            </div>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-col>

    <multiDialog :dialog="dialog" :loading="loading" :resourceSettings="resourceSettings" :deleting="deleting"
      :resourceKeys="resourceKeys" :newResource="newResource" @closeDialog="
        () => {
          dialog = false;
          deleting = false;
          newResource = {};
        }
      " @updateResource="updateResource" @postResource="postResource" @deleteResource="deleteResource" />
</v-row>
</template>

<script>
import Paging from '@/components/Paging'
import multiDialog from '@/components/multiDialog'

export default {
  components: {
    Paging,
    multiDialog
  },
  data() {
    return {
      page: 1,
      loading: false,
      deleting: false,
      dialog: false,
      resource: {},
      newResource: {},
      resourceKeys: [
        { name: 'program_id', label: 'program', type: 'select', items: 'programs', data: [], source: 'db', required: true, readonly: false },
        { name: 'country_id', label: 'country', type: 'select', items: 'countries', source: 'db', data: [], required: true, readonly: false },
        { name: 'valid_start', label: 'valid_start', type: 'date', required: false, readonly: false },
        { name: 'valid_end', label: 'valid_end', type: 'date', required: false, readonly: false },

        { name: 'first_fees', label: 'first_fees', type: 'number', required: false, readonly: false },
        { name: 'first_fees_currency', label: 'first_fees_currency', type: 'text', required: false, readonly: false },
        { name: 'second_fees', label: 'second_fees', type: 'number', required: false, readonly: false },
        { name: 'second_fees_currency', label: 'second_fees_currency', type: 'text', required: false, readonly: false },
      ],
      resourceSettings: {
        resourceName: null,
        search: false,
        create: true,
        pagination: true,
      },
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    language() {
      return this.$store.state.language
    },
    i18n() {
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic() {
      if (this.$store.state.language == 'ar') return true
    },
  },
  methods: {
    editResource(r) {
      this.newResource = { ...r }
      this.newResource.valid_start = this.newResource.valid_start.split("T")[0]
      this.newResource.valid_end = this.newResource.valid_end.split("T")[0]
      this.dialog = true
    },
    triggerDelete(r) {
      this.newResource = { ...r }
      this.deleting = true
      this.dialog = true
    },
    formatDateToCurrentLocale(date) {
      let new_date = (new Date(date))
      return [
        new_date.toLocaleDateString(this.arabic ? 'ar' : 'en', {
          day: 'numeric',
          year: 'numeric',
          month: 'short',
        }),
        new_date.toLocaleTimeString(this.arabic ? 'ar' : 'en'),
      ]
    },
    updateResource(resource) {
      return new Promise(async (res, rej) => {
        this.loading = true
        await this.$store.dispatch('putResource', { resource: `${this.$route.path}/${resource.id}`, value: resource })
        this.loading = false

        this.dialog = false

        await this.loadResource();
        res(true)
      })
    },
    postResource(resource) {
      return new Promise(async (res, rej) => {
        this.loading = true
        await this.$store.dispatch('postResource', { resource: this.$route.path, value: resource, })
        this.loading = false

        this.dialog = false
        this.newResource = {}

        await this.loadResource();
        res(true)
      })
    },
    deleteResource(r) {
      return new Promise(async (res, rej) => {
        this.loading = true
        await this.$store.dispatch('deleteResource', { resource: `${this.$route.path}/${r.id}` })
        this.loading = false

        this.dialog = false

        await this.loadResource();
        res(true)
      })
    },
    async pageByNumber(n) {
      return new Promise(async (res, rej) => {
        this.loading = true
        this.page = n
        this.resource = await this.$store.dispatch('getResource', { resource: this.$route.path, page: `?page=${n}` })
        this.loading = false
        res(true)
      })
    },
    async loadResource() {
      return new Promise(async (res, rej) => {
        this.loading = true
        this.resource = await this.$store.dispatch('getResource', { resource: this.$route.path, page: `?page=${this.page}`, })
        this.loading = false
        res(true)
      })
    },
    setResourceName() {
      this.resourceSettings.resourceName = this.$route.path.replace('/', '')
    },
    async loadItems() {
      return new Promise(async (res, rej) => {
        let iks = ['countries', 'programs'];

        for (let i = 0; i < iks.length; i++) {
          const f = iks[i];
          let t = this.resource[f]
          console.log(t)
          if (!t.error)
            t.forEach(x => this.$store.state.i18n.en[x.slug] = x.en)
          t.forEach(x => this.$store.state.i18n.ar[x.slug] = x.ar)
          t.forEach(x => this.$store.state.i18n.fr[x.slug] = x.fr)
          this[f] = t
        }

        // if (this.user.countries.length == 1) {
        // this.selectedCountry = this.user.countries[0].id
        // }

        let ks = this.resourceKeys.filter(x => x.type == 'select' && x.source == 'db');
        (async x => {
          for (let i = 0; i < ks.length; i++) {
            const f = ks[i];
            console.log(f.items)
            f.data = this.resource[f.items].map(x => {
              return {
                ...x,
                text: x.name ? x.name : x.en ? x.en : 'unknown',
                [`${f.name}_id`]: x.id
              }
            })
          }
          res(true)
        })()
      })
    },
  },
  async created() {
    this.setResourceName()
    await this.loadResource()
    await this.loadItems()
  },
}
</script>